import { useEffect, useState, useRef } from "react";

export default function EnlargeOnHover(props) {
    const { children } = props;

    const componentRef = useRef(null);

    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const childEl = componentRef.current;
        childEl.style.transition = 'transform 0.2s ease-in-out';

        if (isHovered) {
            componentRef.current.style.transform = "scale(1.1)";
        } else {
            componentRef.current.style.transform = "scale(1)";
        }
    }, [isHovered]);

    return (
        <div
            ref={componentRef}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
        </div>
    );
}